/* eslint-disable no-case-declarations */
/* eslint-disable no-param-reassign */

import { Cells } from 'common/types/scalarSpreadsheet';
import { ICell } from 'models/interfaces/spreadsheet-types/core-types';
import { Changes, GetNextCellsChangesParams } from './types';

const afterCellChanged = (changes: Changes[], cells: Cells) => {
  const currentChanges = [...changes];
  const changeList: Changes[] = [];
  const getNextCellsChanges = ({ row, key }: GetNextCellsChangesParams) => {
    const currentIndex = Object.keys(cells).findIndex(item => item === key);

    Object.entries(cells).forEach(([, cell], index) => {
      const isSameRow = cell.rowNumber === row;
      const isNextRow = index > currentIndex;

      if (isSameRow && isNextRow) {
        const expr = cell.isCellCalculated ? cell.exprPair : '';
        currentChanges.push({ cell, value: expr });
      }
    });
  };

  const updateCellStatus = (cell: ICell, isCalculated: boolean) => {
    // Evaluation and reverse parsing share the live Cell instance, including its methods.
    cell.isCellCalculated = isCalculated;
    cell.tooltipMessages = isCalculated ? ['This cell has been calculated automatically'] : null;
    const classes = cell.className?.split(/\s+/).filter(name => name && name !== 'show-tooltip') ?? [];
    cell.className = [...classes, ...(isCalculated ? ['show-tooltip'] : [])].join(' ');
  };

  currentChanges.forEach(change => {
    const { cell, value } = change;
    const { key, rowNumberPair, columnLegend, rowNumber: row } = cell;

    // If is a cell with pair cell and it's not the first column
    if (rowNumberPair && columnLegend !== 'A') {
      const pairCellKey = `${columnLegend}${rowNumberPair}`;
      const pairCell = cells[pairCellKey];
      const { exprPair } = pairCell;
      cell.pairCell = pairCell;
      pairCell.pairCell = cell;

      updateCellStatus(cell, false);
      changeList.push({ cell, value });

      // Update current cell changed pair status
      updateCellStatus(pairCell, true);
      changeList.push({ cell: pairCell, value: exprPair });

      getNextCellsChanges({ row, key });
    } else {
      changeList.push({ cell, value });
    }
  });

  return changeList;
};

export default afterCellChanged;
